import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog modal-sm modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content rounded" }
const _hoisted_4 = { class: "modal-header justify-content-space-between" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  type: "button",
  class: "close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "×")
  ])
], -1)
const _hoisted_6 = {
  class: "modal-body bg-white p-0",
  style: {"max-height":"250px"}
}
const _hoisted_7 = { class: "image-slot" }
const _hoisted_8 = { class: "modal-footer d-flex flex-row gap-5 justify-content-center" }
const _hoisted_9 = {
  key: 1,
  for: "upload-file",
  class: "btn btn-primary align-self-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_picture = _resolveComponent("icon-picture")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: _ctx.modalId,
    tabindex: "-1",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.title), 1),
          _hoisted_5
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_image, {
            src: _ctx.imageDisplay,
            class: "align-middle",
            lazy: "",
            fit: "contain",
            style: {
              width: `100%`,
              height: `250px`,
              minHeight: `250px`,
            }
          }, {
            error: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_icon_picture)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["src"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "btn align-self-center btn-light",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.remove && _ctx.remove(...args)))
          }, " Remove "),
          (_ctx.editMode)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                "data-bs-dismiss": "modal",
                class: "btn btn-primary align-self-center",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
              }, " Save "))
            : (_openBlock(), _createElementBlock("label", _hoisted_9, [
                _createTextVNode(" Change "),
                _createElementVNode("input", {
                  type: "file",
                  id: "upload-file",
                  hidden: "",
                  onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFileHandle && _ctx.onFileHandle(...args)))
                }, null, 32)
              ]))
        ])
      ])
    ])
  ], 8, _hoisted_1))
}